import apiClient from './apiClient';

export interface SandboxStatusResponse {
    connected: boolean;
    baseUrl: string;
    locationId?: string;
    error?: string;
    credentials: {
        userId: boolean;
        apiKey: boolean;
        developerId: boolean;
        locationId: boolean;
    };
}

export class FortisService {
    static async getSandboxStatus(): Promise<SandboxStatusResponse> {
        return apiClient.get<SandboxStatusResponse>('/api/admin/fortis/sandbox/status');
    }

    static async sandboxContacts(body: Record<string, unknown>): Promise<unknown> {
        return apiClient.post('/api/admin/fortis/sandbox/contacts', body);
    }

    static async sandboxTransactions(body: Record<string, unknown>): Promise<unknown> {
        return apiClient.post('/api/admin/fortis/sandbox/transactions', body);
    }

    static async sandboxRecurrings(body: Record<string, unknown>): Promise<unknown> {
        return apiClient.post('/api/admin/fortis/sandbox/recurrings', body);
    }

    static async sandboxInvoices(body: Record<string, unknown>): Promise<unknown> {
        return apiClient.post('/api/admin/fortis/sandbox/invoices', body);
    }

    static async sandboxOnboarding(body: Record<string, unknown>): Promise<unknown> {
        return apiClient.post('/api/admin/fortis/sandbox/onboarding', body);
    }

    static async sandboxLocations(locationId?: string): Promise<unknown> {
        const qs = locationId ? `?locationId=${encodeURIComponent(locationId)}` : '';
        return apiClient.get(`/api/admin/fortis/sandbox/locations${qs}`);
    }

    static async sandboxGetWebhooks(): Promise<unknown> {
        return apiClient.get('/api/admin/fortis/sandbox/webhooks');
    }

    static async sandboxWebhooks(body: Record<string, unknown>): Promise<unknown> {
        return apiClient.post('/api/admin/fortis/sandbox/webhooks', body);
    }

    static async sandboxElements(body: Record<string, unknown>): Promise<unknown> {
        return apiClient.post('/api/admin/fortis/sandbox/elements', body);
    }

    static async sandboxTerminals(body: Record<string, unknown>): Promise<unknown> {
        return apiClient.post('/api/admin/fortis/sandbox/terminals', body);
    }
}

export default FortisService;
